import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import { observer } from 'mobx-react-lite';
import { FullConsent } from './FullConsent';
import { MinimalConsent } from './MinimalConsent';

export const ConsentStep = observer(() => {
    const createAvatarStore = useCreateAvatarStore();

    if (createAvatarStore.skipConsent) {
        return <MinimalConsent />;
    }

    return <FullConsent />;
});
